import Vue from 'www/vue_components'
import LpuNotWorkingLabel from 'www/vue_components/common/LpuNotWorkingLabel/LpuNotWorkingLabel.vue'

// @ts-ignore
const mountElements = [...document.querySelectorAll('.vue-mount-lpu-not-working-label')]

if (mountElements) {
  mountElements.forEach(mountElement => {
    new Vue({
      el: mountElement,
      components: {
        LpuNotWorkingLabel,
      },
    })
  })
}
